import { ChangeDetectionStrategy, Component } from '@angular/core';
import { select } from '@ngxs/store';

import { ToastSelectors } from '@efficiently/client-core-toast';

import { ToastComponent } from './toast/toast.component';

@Component({
	selector: 'ds-toasts',
	imports: [ToastComponent],
	templateUrl: './toasts.component.html',
	styleUrls: ['./toasts.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastsComponent {
	public messages = select(ToastSelectors.messages);
}
